<div class="back-home">
  <button type="button" class="btn btn-sm pl-0 ml-0" [routerLink]="'../..'">
    <span><i class="icon icon-arrow-back-breadcrumb text-uppercase" aria-hidden="true"></i>Home</span>
  </button>
</div>
<div class="section-name col-sm-6 col-lg-12 p-0">
  All Files
</div>

<!-- Files dashboard -->
<div class="mb-5">
  <!-- Tile view -->
  <div class="col col-4 pl-0 pr-0">
    <app-dropdown-sort (select)="onTileSort($event)"></app-dropdown-sort>
  </div>
  <div class="file-tiles">
      <app-asset-tile *ngFor="let file of files" class="tile" [data]="file" [showDelete]="false"></app-asset-tile>
  </div>
</div>

<button type="button" *ngIf="!!lastEvaluatedKey" class="btn btn-link link-arrow more-results float-right text-right text-uppercase pr-0 mr-0" (click)="getNext()">
  More results<i class="icon icon-arrow-fwd-sm-link"></i>
</button>
